<template>

    <div class="hero-section">
        <img :src="require('@/assets/arts/lightstop.svg')" class="art-hero-lights" alt="" aria-hidden="true">
        <div class="container">
        <div class="row">
            <div class="col-12 text-center text-white">
                <div class="row introtext">
                <h2 class="titreintro">Votre coin de paradis,</h2>
                <div class="col-3"></div>
                <div class="col-md-6">
                    au bord du lac d'Annecy pour déguster des cocktails délicieux et vivre des instants conviviaux. Reconnu pour son ambiance décontractée et son service amical, notre établissement offre des petits déjeuners face au lac et des soirées animées. Avec une équipe dynamique et des événements réguliers, c'est l'endroit idéal pour se détendre et s'amuser en bonne compagnie.
                </div>
                    <div class="col-3"></div>
                </div>
            </div>
        </div>
        </div>
    </div>
    <div class="cards-section">
      <div class="cards-grid">
        <div class="card-item" v-for="photo in photos" :key="photo.id" :class="'card-color-' + photo.id">
          <img :src="getImagePath(photo.fileName)" :alt="photo.alt" class="card-bg">
          <div class="card-content">
            <img :src="getIconPath(photo.icon)" :alt="photo.alt" class="card-icon">
            <h3 v-html="photo.title"></h3>
          </div>
          <div class="card-description">
            <p>{{ photo.description }}</p>
          </div>
        </div>
      </div>

      <!-- Nos Cartes -->
      <div class="cartes-section">
        <h2 class="section-title">Nos Cartes</h2>
        <div class="cartes-grid">
          <router-link to="/carte" class="carte-link">
            <img :src="require('@/assets/gallery/7.jpg')" alt="Carte Boissons" class="carte-img">
            <div class="carte-overlay">
              <h3>Carte Boissons</h3>
            </div>
          </router-link>
          <router-link to="/foodtruck" class="carte-link">
            <img :src="require('@/assets/gallery/26.jpg')" alt="Carte Foodtruck" class="carte-img">
            <div class="carte-overlay">
              <h3>Carte Foodtruck</h3>
            </div>
          </router-link>
        </div>
      </div>

      <div class="insta-widget">
        <iframe src="https://cdn.lightwidget.com/widgets/ce592f7f15055389a61fc9da5738e1b4.html" scrolling="no" allowtransparency="true" class="lightwidget-widget" style="width:100%;border:0;overflow:hidden;"></iframe>
      </div>
    </div>

    <div class="maison-section">
      <div class="maison-overlay"></div>
      <div class="maison-content">
        <h2>La soirée continue à <b>La Maison</b></h2>
        <p>La soirée ne fait que commencer ! Rendez-vous à La Maison jusqu'à 2h !</p>
        <a href="https://www.google.com/maps/dir/Le+Cabanon,+Avenue+du+Petit+Port,+Annecy/La+Maison+2A+Quai+Perri%C3%A8re+74000+Annecy/@45.9017115,6.1341387,16z/" target="_blank" class="btn-maison">Itinéraire</a>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'App',
    data() {
      return {
        hover: 'no',
        photos: [
          { id: 1,
            fileName: "2.jpg",
            images: [
              "2.jpg",
              "3.jpg",
              "9.jpg",
              "2.jpg",
            ],
            icon: "sun",
            alt: "Terrasse au bord du lac d'Annecy",
            title: "Terrasse<br>au Lac",
            description: "Découvrez le charme unique de notre terrasse ensoleillée au bord du lac d'Annecy. Un lieu convivial près des terrains de bouliste, parfaitement accessible via la piste cyclable. Reposez-vous sous la fraîcheur des arbres.",
            overlayColor: "rgba(228, 228, 184, 0.9)"
          },
          { id: 2,
            fileName: "24.jpg",
            images: [
              "33.jpg",
              "24.jpg",
              "5.jpg",
              "24.jpg",
            ],
            icon: "breakfast",
            alt: "Petits déjeuners au Cabanon",
            title: "Matins Gourmands",
            description: "Commencez votre journée en beauté avec nos petits déjeuners gourmands. Savourez une tasse de café aromatique et une sélection de viennoiseries fraîches tout en profitant de la vue imprenable sur le lac.",
            overlayColor: "rgba(202, 220, 224, 0.9)"
          },
          { id: 3,
            fileName: "20.jpg",
            images: [
              "20.jpg",
              "26.jpg",
              "20.jpg",
              "16.jpg",
            ],
            icon: "food",
            alt: "Foodtrucks au Cabanon",
            title: "Plaisirs Culinaires",
            description: "Rejoignez-nous pour un déjeuner ou un dîner festif avec une rotation alléchante de foodtrucks. Du BBQ aux crêpes, en passant par les burgers, il y a toujours quelque chose de nouveau et excitant à goûter chez nous.",
            overlayColor: "rgba(243, 207, 151, 0.9)"
          },
          { id: 4,
            fileName: "19.jpg",
            images: [
              "19.jpg",
              "21.jpg",
              "31.jpg",
              "19.jpg",
            ],
            icon: "dj",
            alt: "Soirées avec DJ au Cabanon",
            title: "Nuits Enchantées",
            description: "L'ambiance se transforme à la tombée de la nuit. Nos soirées avec DJ sont l'essence d'une ambiance décontractée. Laissez-vous emporter par la musique et dansez sous les étoiles lors de nos événements nocturnes.",
            overlayColor: "rgba(227, 189, 185, 0.9)"
          }
        ],
      };
    },
    methods: {
      getImagePath(fileName) {
        // Vous pouvez aussi choisir d'utiliser directement les chemins relatifs si vous préférez.
        return require('@/assets/gallery/' + fileName);
      },
      getIconPath(fileName) {
        // Vous pouvez aussi choisir d'utiliser directement les chemins relatifs si vous préférez.
        return require('@/assets/' + fileName + '.svg');
      },
    }
  };
  </script>

  <style scoped>
  .art-hero-lights {
    position: absolute;
    right: -80px;
    top: -100px;
    width: 300px;
    pointer-events: none;
    z-index: 3;
    opacity: 0.8;
  }

  /* Section cards */
  .cards-section {
    max-width: 1100px;
    margin: 0 auto;
    padding: 50px 20px;
  }

  .cards-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }

  /* Cards : full image avec overlay */
  .card-item {
    position: relative;
    border-radius: 14px;
    overflow: hidden;
    height: 280px;
    cursor: pointer;
    box-shadow: 0 6px 24px rgba(27,51,69,0.15);
  }

  .card-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.5s ease;
  }
  .card-item:hover .card-bg {
    transform: scale(1.08);
  }

  /* Contenu toujours visible : icône + titre */
  .card-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px 16px 16px;
    background: linear-gradient(transparent 0%, rgba(0,0,0,0.65) 100%);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    transition: opacity 0.3s ease;
  }
  .card-icon {
    width: 1.8em;
    margin-bottom: 6px;
    filter: brightness(10);
    opacity: 0.9;
  }
  .card-content h3 {
    font-family: 'Montserrat', sans-serif;
    font-size: 1em;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: white;
    margin: 0;
    line-height: 1.2;
    text-shadow: 0 2px 12px rgba(0,0,0,0.5);
  }

  /* Description au hover : glass morphism */
  .card-description {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(27, 51, 69, 0.85);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    opacity: 0;
    transition: opacity 0.4s ease;
  }
  .card-item:hover .card-description {
    opacity: 1;
  }
  .card-item:hover .card-content {
    opacity: 0;
  }
  .card-description p {
    color: white;
    font-size: 0.85em;
    line-height: 1.5;
    text-align: justify;
    margin: 0;
    font-weight: 300;
  }

  /* Bordures colorées */
  .card-color-1 { border: 3px solid #44bfb1; }
  .card-color-2 { border: 3px solid #3c7397; }
  .card-color-3 { border: 3px solid #f387a2; }
  .card-color-4 { border: 3px solid #1b3345; }

  /* Section Nos Cartes */
  .cartes-section {
    margin-top: 50px;
  }
  .section-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.4em;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 3px;
    color: #1b3345;
    text-align: center;
    margin-bottom: 24px;
  }
  .cartes-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  .carte-link {
    position: relative;
    display: block;
    border-radius: 18px;
    overflow: hidden;
    height: 200px;
    box-shadow: 0 6px 24px rgba(27,51,69,0.15);
    transition: transform 0.3s, box-shadow 0.3s;
    border: 3px solid #44bfb1;
  }
  .carte-link:nth-child(2) {
    border-color: #f387a2;
  }
  .carte-link:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 30px rgba(27,51,69,0.25);
  }
  .carte-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
  .carte-link:hover .carte-img {
    transform: scale(1.06);
  }
  .carte-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(27,51,69,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease;
  }
  .carte-link:hover .carte-overlay {
    background: rgba(27,51,69,0.7);
  }
  .carte-overlay h3 {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.5em;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 3px;
    color: white !important;
    text-shadow: 0 2px 10px rgba(0,0,0,0.4);
    margin: 0;
  }

  /* Widget insta */
  .insta-widget {
    margin-top: 40px;
  }

  /* Section La Maison */
  .maison-section {
    position: relative;
    background-image: url('~@/assets/gallery/lamaison.jpg');
    background-size: cover;
    background-position: center;
    min-height: 40vh;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
  }
  .maison-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(27, 51, 69, 0.6);
  }
  .maison-content {
    position: relative;
    z-index: 2;
    text-align: center;
    color: white;
    padding: 60px 20px;
  }
  .maison-content h2 {
    font-family: 'Adventures Unlimited', cursive;
    font-size: 7em;
    margin-bottom: 16px;
    text-shadow: 0 2px 10px rgba(0,0,0,0.3);
  }
  .maison-content p {
    font-size: 1.1em;
    margin-bottom: 24px;
    font-weight: 300;
  }
  .btn-maison {
    display: inline-block;
    background-color: transparent;
    color: white !important;
    border: 2px solid white;
    border-radius: 30px;
    padding: 12px 30px;
    font-size: 1em;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-decoration: none !important;
    transition: all 0.3s ease;
  }
  .btn-maison:hover {
    background-color: #eded87;
    color: #1b3345 !important;
    border-color: #eded87;
  }

  /* Tablette */
  @media (max-width: 1024px) {
    .cards-section {
      padding: 40px 20px;
    }
    .cards-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .card-item {
      height: 260px;
    }
    .card-content h3 {
      font-size: 0.95em;
    }
    .card-description p {
      font-size: 0.85em;
    }
    .cartes-section {
      margin-top: 40px;
    }
    .carte-link {
      height: 170px;
    }
    .carte-overlay h3 {
      font-size: 1.2em;
      letter-spacing: 2px;
    }
    .maison-content h2 {
      font-size: 5em;
    }
    .maison-content {
      padding: 40px 20px;
    }
  }

  /* Mobile */
  @media (max-width: 768px) {
    .art-hero-lights {
      width: 180px;
      right: -40px;
      top: -60px;
    }
    .cards-section {
      padding: 30px 15px;
    }
    .cards-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
    }
    .card-item {
      height: 200px;
    }
    .card-content {
      padding: 12px 10px 10px;
    }
    .card-content h3 {
      font-size: 0.8em;
      letter-spacing: 1px;
    }
    .card-icon {
      width: 1.4em;
      margin-bottom: 4px;
    }
    .card-description {
      padding: 14px;
    }
    .card-description p {
      font-size: 0.75em;
      line-height: 1.4;
    }
    .cartes-section {
      margin-top: 30px;
    }
    .section-title {
      font-size: 1.1em;
      letter-spacing: 2px;
    }
    .cartes-grid {
      gap: 14px;
    }
    .carte-link {
      height: 130px;
    }
    .carte-overlay h3 {
      font-size: 0.95em;
      letter-spacing: 1.5px;
    }
    .maison-section {
      min-height: auto;
      margin-top: 20px;
    }
    .maison-content {
      padding: 30px 15px;
    }
    .maison-content h2 {
      font-size: 3em;
    }
    .maison-content p {
      font-size: 0.85em;
      margin-bottom: 16px;
    }
    .btn-maison {
      padding: 8px 20px;
      font-size: 0.85em;
    }
    .insta-widget {
      margin-top: 20px;
    }
    .cartes-section {
      margin-top: 20px;
    }
    .section-title {
      font-size: 1em;
    }
  }

  /* Petit mobile */
  @media (max-width: 480px) {
    .cards-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }
    .card-item {
      height: 180px;
    }
    .card-content h3 {
      font-size: 0.75em;
    }
    .cartes-grid {
      grid-template-columns: 1fr;
      gap: 12px;
    }
    .carte-link {
      height: 130px;
    }
    .carte-overlay h3 {
      font-size: 1em;
    }
    .maison-content h2 {
      font-size: 2.5em;
    }
    .maison-content p {
      font-size: 0.8em;
    }
  }
  </style>
